function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor"
}, React.createElement("path", {
  d: "M6.527 16.153l9.987-9.987 1.414 1.415-9.986 9.986z"
}), React.createElement("path", {
  d: "M6.48 5.61h12v2h-12z"
}), React.createElement("path", {
  d: "M18.48 5.61v12h-2v-12z"
}));

var SvgOpenArrow = function SvgOpenArrow(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24
  }, props), _ref);
};

export default SvgOpenArrow;